<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="pt01">
<h1 class="part"><a id="page1"></a><a class="hlink" href="#/text/9780062378576_B1_Contents#pt01a">Part I</a></h1>
<div class="block">
<p class="nonindent"><em>“And that I walk thus proudly crowned withal<br/>Is that ‘tis my distinction; if I fall,<br/>I shall not weep out of the vital day,<br/>To-morrow dust, nor wear a dull decay”</em></p>
<p class="right">Percy Bysshe Shelley,<br/>“And That I Walk Thus<br/>Proudly Crowned Withal”</p>
</div>
<div class="block">
<p class="nonindent"><em>“When I was small and five<br/>I found a pencil sharpener alive!<br/>He lay in lonely grasses<br/>Looking for work.<br/>I bought a pencil for him.<br/>He ate and ate until all that was<br/>Left was a pile of wood dust.<br/>It was the happiest pencil sharpener<br/>I ever had”</em></p>
<p class="right">Spike Milligan, “2B or not 2B”</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062378576_B1_Part_1.vue?7349d20c